import Navbar from '@/components/feature/Navbar'
import Footer from '@/components/feature/Footer'
import SEOHead from '@/components/feature/SEOHead'
import HeroSection from './components/HeroSection'
import CategorySection from './components/CategorySection'
import FeaturedGrid from './components/FeaturedGrid'
import StatsSection from './components/StatsSection'
import NewsletterSection from './components/NewsletterSection'

export default function Home() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫画网 - 免费在线观看韩国漫画',
    description: '韩漫画网支持免费在线观看韩国漫画和好看的韩漫大全，资源分类细致搜索方便，帮助您快速发现热门漫画作品。',
    url: 'http://eocesp.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫画网',
      url: 'http://eocesp.cn/',
    },
    about: {
      '@type': 'Thing',
      name: '韩国漫画',
      description: '韩国漫画（韩漫）在线免费阅读平台',
    },
  }

  return (
    <>
      <SEOHead
        title="韩漫画网-免费在线观看韩国漫画-好看的韩漫大全"
        description="韩漫画网支持免费在线观看韩国漫画和好看的韩漫大全，资源分类细致搜索方便，帮助您快速发现热门漫画作品。恋爱、奇幻、动作、悬疑、搞笑等分类一应俱全。"
        keywords="韩漫画网,免费在线观看韩国漫画,好看的韩漫大全,韩国漫画,韩漫,在线漫画,免费漫画"
        canonicalUrl="http://eocesp.cn/"
        schema={schema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedGrid />
        <StatsSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  )
}